import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useLocation } from "react-router";
export default function BuyBtnProductCard({ id, isOpen }) {
	const StyledComponent = styled(Avatar)(({ theme }) => ({
		transition: "0.3s",
		width: 40,
		backgroundColor: theme.palette.info.light,
		height: 40,
		boxShadow: "0 4px 12px 0 rgba(0,0,0,0.24)",
		borderRadius: "0.5rem",
		zIndex: 10,
		[theme.breakpoints.down("sm")]: {
			width: 30,
			height: 30,
		},
	}));

	const location = useLocation().pathname;

	if (!location.includes("gestion") && isOpen)
		return (
			<StyledComponent>
				<AddShoppingCartIcon />
			</StyledComponent>
		);
	else return null;
}
